import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';

class ApplicationRefEntity extends Entity {
  static fields: EntityFields<ApplicationRefEntityFields> = {
    uuid: new Fields.IdField(),
    name: new Fields.CharField({ blank: true, local: true }),
    slug: new Fields.CharField({ blank: true, local: true }),
  };
}

export type ApplicationRefEntityFields = {
  uuid: string;
  name: string;
  slug: string;
};

export type ApplicationRefEntityRecord =
  EntityRecord<ApplicationRefEntityFields>;

export default ApplicationRefEntity;
